import abstractModel from '../core/MercatelyModel';
import { MERCATELY_API } from '../constants/AppConstants';

const resource = `${MERCATELY_API}/bsp/call_permissions`;

const model = abstractModel(resource);

/**
 * @param {string} phoneNumber
 * @param {{ appId?: string, platformRetailerId?: string, integrationPlatform?: string }} [lineScope]
 */
model.getCallPermissionStatus = async (phoneNumber, lineScope = {}) => {
  const params = { phone_number: phoneNumber };
  if (lineScope.appId) params.app_id = lineScope.appId;
  if (lineScope.platformRetailerId) params.platform_retailer_id = lineScope.platformRetailerId;
  if (lineScope.integrationPlatform) params.integration_platform = lineScope.integrationPlatform;
  return model.get(params);
};

/**
 * @param {string} phoneNumber
 * @param {string} [text]
 * @param {{ appId?: string, platformRetailerId?: string, integrationPlatform?: string }} [lineScope]
 */
model.requestCallPermission = async (phoneNumber, text, lineScope = {}) => {
  const body = { phone_number: phoneNumber, text };
  if (lineScope.appId) body.app_id = lineScope.appId;
  if (lineScope.platformRetailerId) body.platform_retailer_id = lineScope.platformRetailerId;
  if (lineScope.integrationPlatform) body.integration_platform = lineScope.integrationPlatform;
  return model.save(body);
};

export default model;
